import { render } from "./CommunityShorts.vue?vue&type=template&id=eef82ff6"
import script from "./CommunityShorts.vue?vue&type=script&lang=js"
export * from "./CommunityShorts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__